module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp1_6000.dc275796.png";